 <div class="row" style="padding-top: 5px;">
   <div class="col-lg-12">



     <app-table-title [inboxUnreadCount]="InboxCount" *ngIf="user?.UserInformation" [fontSize]="'24px'" [title]="differentLoggedIn ? ('USER' | dictionary) : (('WELCOME' | dictionary) + ', ') + user.UserInformation.UserName"></app-table-title>
     <div class="m-portlet m-portlet--unair">
       <app-announcement-block [announcements]="Announcements"></app-announcement-block>
     </div>
   </div>
 </div>

 <app-portfolio-block  [userInfo]="user"
                      [user]="user?.UserInformation"
                      [differentLoggedIn]="differentLoggedIn" [label]="'USER' | dictionary"></app-portfolio-block>


 <div class="row">

   <app-documents-block class="col-lg-6" [label]="'USER' | dictionary"  [statements]="statements"
                        [communications]="communications" [taxes]="taxes"
                        [differentLoggedIn]="differentLoggedIn"></app-documents-block>

   <div class="col-lg-6">
     <app-forms-block [forms]="forms" [label]="'USER' | dictionary" [differentLoggedIn]="differentLoggedIn"></app-forms-block>
     <app-contacts [contacts]="contacts"></app-contacts>
   </div>

 </div>

 <div class="row">
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">

 </app-pop-up-dialog>
